<template>
  <p-progress-bar
    mode="indeterminate"
    v-bind="$attrs"
  />
</template>
